import { Component } from '@angular/core';
@Component({
    templateUrl: './purchase-history-page.component.html',
    styleUrls: ['./purchase-history-page.component.scss']
})
export class PurchaseHistoryPageComponent {}
